import { createSelector } from '@reduxjs/toolkit';
import { DealStatus, DealType } from 'components/common/types/Deal.types';
import { Store } from 'components/common/types/Store.types';
import { CampaignType } from 'components/pages/Planner/PlannerSections/types';
import { getDealType } from './getDealType';

export const getIsProgrammaticEndedAddNewLineEnabled = createSelector(
  [
    (state: Store) => state.dealManagement.commonDeal.bookingStatusCode,
    getDealType,
    (state: Store) => state.dealManagement.campaignType,
    (state: Store) => state.dealManagement.commonDeal.currentLine,
  ],
  (bookingStatusCode, dealType, campaignType, currentLine) => {
    const isNewLine = !currentLine?.id || !currentLine?.lineId;

    return (
      campaignType === CampaignType.PROGRAMMATIC &&
      [DealStatus.ENDED, DealStatus.TERMINATED].includes(bookingStatusCode) &&
      [DealType.NON_GUARANTEED_FLOOR_PRICE, DealType.NON_GUARANTEED_FIXED_PRICE].includes(dealType) &&
      isNewLine
    );
  },
);
